<script>
import storeResultsInModal from '@phoenix/mixins/components/store/storeResultsInModal';
import { PhxIcon } from '@phx-styleguides/jlc';

export default {
  components: {
    PhxIcon,
  },

  mixins: [storeResultsInModal],

  props: {
    storeListClasses: {
      type: String,
      default: '',
    },
    storeListLinkClasses: {
      type: String,
      default: '',
    },
  },
};
</script>

<template>
  <div>
    <div v-if="isLoading" class="flex flex-grid--center">
      <div class="loader loader--dark">
        <div class="loader__inner"></div>
      </div>
    </div>

    <ul v-else-if="hasStore" class="menu menu--sm menu--border-full-width" :class="storeListClasses">
      <li class="menu__item">
        <slot name="before-store-list" />
      </li>

      <li v-for="store in stores" :key="store.id" data-cy="store-result-item" class="menu__item">
        <a
          :href="storeLink(store.permalink)"
          class="menu__entry menu__entry--tight menu__link menu__toggle"
          :class="storeListLinkClasses"
          v-on="followStoreLinkOnClick ? {} : { click: () => storeClick(store) }"
        >
          <address class="checkout__store-list-address">
            <strong>{{ store.name }}</strong>
            {{ getFullAddress(store) }}
          </address>

          <phx-icon icon="chevron-16" bidirectional />
        </a>
      </li>
    </ul>

    <div v-else-if="displayNoResult" class="text-center">
      <h4 v-if="noResultTitle">
        {{ noResultTitle }}
      </h4>
      <p v-if="noResultText">
        {{ noResultText }}
      </p>
      <div v-if="noResultCTA" class="mt-base">
        <c-t-a v-bind="noResultCTA" />
      </div>
    </div>
  </div>
</template>
